import type { PastDueAccountMetrics } from "types/landlord/reports";
import { toFixedFloored } from "utils/toFixedFloored";

export const getPastDueAccountMetricValue = ({
  metrics,
  isPercentage
}: {
  metrics?: PastDueAccountMetrics | null;
  isPercentage: boolean;
}): number | null => {
  if (!metrics) return null;

  if (isPercentage) {
    if (!metrics.total_accounts) return null;
    return metrics.percentage;
  }

  return metrics.count;
};

export const formatPastDueAccountDisplay = ({
  metrics,
  isPercentage,
  noData = false
}: {
  metrics?: PastDueAccountMetrics | null;
  isPercentage: boolean;
  noData?: boolean;
}): string | number => {
  if (noData) return "No data";

  const value = getPastDueAccountMetricValue({ metrics, isPercentage });
  if (value === null) return "-";

  if (isPercentage) return `${toFixedFloored(value, 2)}%`;

  return value;
};
